import { render, staticRenderFns } from "./questionAsk.vue?vue&type=template&id=38a1f6ae&scoped=true"
import script from "./questionAsk.vue?vue&type=script&lang=js"
export * from "./questionAsk.vue?vue&type=script&lang=js"
import style0 from "./questionAsk.vue?vue&type=style&index=0&id=38a1f6ae&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a1f6ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38a1f6ae')) {
      api.createRecord('38a1f6ae', component.options)
    } else {
      api.reload('38a1f6ae', component.options)
    }
    module.hot.accept("./questionAsk.vue?vue&type=template&id=38a1f6ae&scoped=true", function () {
      api.rerender('38a1f6ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/questionType/questionAsk.vue"
export default component.exports